import axios from "axios";

const deleteObjectFile = async (fileId) => {
  const token = localStorage.getItem("token");
  const res = await axios.delete(
    `${process.env.REACT_APP_URL_BACKEND}api/v1/object-files/${fileId}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );
  const data = await res.data;
  return { data, res };
};

export default deleteObjectFile;
